import React, { createContext, useContext } from 'react';

export type ToastMessage = {
    id?: number | undefined ;
    message: string;
    type: 'success' | 'error' | 'warning' | 'info';
};

type ToastContextType = {
    addToast: (message: ToastMessage) => void;
};

export const ToastContext = createContext<ToastContextType | undefined>(undefined);

export const useToast = () => {
    const context = useContext(ToastContext);
    if (!context) {
        throw new Error('useToast must be used within a ToastProvider');
    }
    return context;
};
